import type { SponsorPlanItem } from '@app/_proto/Protos/sponsors';
import { convertMinusException } from '@app/domains/champion/utils/convertMinusException';

export const sortSponsorPlans = (championPlans: SponsorPlanItem[] | undefined) => {
    if (!championPlans) return [];

    const plansArray = [...championPlans];
    plansArray.sort(
        (a, b) => convertMinusException(a.advanceChapterCount) - convertMinusException(b.advanceChapterCount)
    );
    return plansArray;
};
